import { Member } from "@/types/utils";
import { Box, Typography } from "@mui/material";
import { GridColDef, GridRowSpacingParams } from "@mui/x-data-grid";
import { useCallback, useMemo } from "react";
const useTableHelper = () => {
    const getRandomColor = useMemo(() => {
        const randomColor = Math.floor(Math.random() * 16777215).toString(16);
        return `#${randomColor.padStart(6, "0")}`;
    }, []);

    const columns = (): GridColDef[] => {
        return [
            {
                field: "name",
                headerName: "Name",
                flex: 1,
                headerAlign: "left",
                renderCell: params => {
                    const { name } = params.row;
                    const firstLetter = name[0];

                    return (
                        <Box display="flex" gap="8px" alignItems="center">
                            <Box
                                width="32px"
                                height="32px"
                                bgcolor={getRandomColor}
                                borderRadius="100%"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                fontWeight={700}
                                color="black"
                                fontSize="18px"
                            >
                                {firstLetter}
                            </Box>
                            <Typography fontWeight={700} fontSize="14px">
                                {name}
                            </Typography>
                        </Box>
                    );
                },
            },
            {
                field: "email",
                headerName: "Email",
                flex: 1,
                headerAlign: "left",
            },
            {
                field: "role",
                headerName: "Team permission",
                flex: 1,
                headerAlign: "right",
                align: "right",
                renderCell: params => {
                    const parsedRole = params.row.role.replace("_", " ");

                    return (
                        <Typography fontSize="14px" padding="24px">
                            {parsedRole.charAt(0).toUpperCase() + parsedRole.slice(1).toLowerCase()}
                        </Typography>
                    );
                },
            },
        ];
    };

    const rows = (data: Member[]) => {
        return data
            ? data.map(member => {
                  return {
                      id: member._id,
                      name: member.displayName ?? "Unknown",
                      email: member.email,
                      role: member.role,
                  };
              })
            : [];
    };

    const getRowSpacing = useCallback((params: GridRowSpacingParams) => {
        return {
            top: params.isFirstVisible ? 0 : 4,
            bottom: params.isLastVisible ? 0 : 4,
        };
    }, []);

    return { columns, rows, getRowSpacing };
};

export { useTableHelper };
